import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgxSplideModule } from 'ngx-splide';
import { sliderOptions } from '@app/domain/properties/slider.properties';

@Component({
  selector: 'bingo-how-to-win-tutorial',
  imports: [NgxSplideModule],
  templateUrl: './how-to-win-tutorial.component.html',
  styleUrl: './how-to-win-tutorial.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HowToWinTutorialComponent {
  protected readonly sliderOptions = sliderOptions;
}
